import { render, staticRenderFns } from "./StrategyBenefit.vue?vue&type=template&id=6f56d4c7&scoped=true&"
import script from "./StrategyBenefit.vue?vue&type=script&lang=js&"
export * from "./StrategyBenefit.vue?vue&type=script&lang=js&"
import style0 from "./StrategyBenefit.vue?vue&type=style&index=0&id=6f56d4c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f56d4c7",
  null
  
)

export default component.exports